import CssBaseline from '@mui/material/CssBaseline';
import { ConfirmProvider } from 'material-ui-confirm';
import { ThemeProvider } from '@mui/material/styles';

import { AuthContext } from './context/AuthProvider';
import { useAuth } from './hooks/useAuth';
import { useRoutes } from './hooks/useRoutes';
import { BrowserTitle, Spinner } from './components';

import { light_theme, dark_theme } from './utils/theme';
import UpdateBanner from './components/UpdateBanner';
import ChunkErrorBoundary from './components/ChunkErrorBoundary';

export default function App() {
  const { token, login, logout, loading, userData } = useAuth();
  const isAuthenticated = !!token;
  const routes = useRoutes(isAuthenticated, userData);

  if (!loading) {
    return <Spinner />;
  }

  // Role-gated routes (warranty-tickets, archive, mailer, ...) are only
  // registered once the profile is known. Rendering the router before that
  // would hit the catch-all redirect and dump the user on /appointments
  // after a page refresh, so wait for userData first.
  if (isAuthenticated && !userData) {
    return <Spinner />;
  }

  return (
    <AuthContext.Provider
      value={{
        token,
        login,
        logout,
        isAuthenticated,
        userData,
      }}
    >
      <BrowserTitle title="Airmaxx Pro" />
      <CssBaseline />
      <ThemeProvider theme={light_theme}>
        <ConfirmProvider>
          <ChunkErrorBoundary>{routes}</ChunkErrorBoundary>
        </ConfirmProvider>
        <UpdateBanner />
      </ThemeProvider>
    </AuthContext.Provider>
  );
}
